<template>
    <div class="igc-face-img" v-if="isShow">
        <div class="ig-img-box" ref="box">
            <div @click="out">
                <div class="ig--close" @click.stop="next" :style="{'background': mColor(4)}">
                    <sui-icon class="ig--icon" name="close" :fill="mColor(7)"></sui-icon>
                </div>
                <img :src="_url" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import mCore from '../../scripts/mixins/core'
    import {dynamicApi} from '../../scripts/api/dynamicApi'

    export default {
        name: "face_img",
        mixins: [mCore],
        props: {
            include: {
                type: Array,
                require: true
            }
        },

        data() {
            return {
                isInclude: false,
                active: 0,
                list: [],
                vList: [],
                hList: [],
            }
        },
        computed: {
            _url() {
                return this.list[this.active] ? this.list[this.active].img_url || '' : '';
            },
            isShow() {
                return this.active < this.list.length && this.isInclude;
            }
        },
        watch: {
            $route(to, from) {
                for (let i = 0; i < this.include.length; i++) {
                    if (this.include[i] === this.$route.name) {
                        this.isInclude = true;
                    }
                }
            },
            _url(val) {
                if (val !== '') {
                    //当图片展示成功,当日显示次数和总次数才会加1
                    // const faceImg = JSON.parse(localStorage.faceImg || '{}');
                    // const m = faceImg.m, key = this.list[this.active].id;
                    // if (m[key]) { //如果这个key对应的数据不存在，则什么都不做
                    //     m[key] = {daily: m[key].daily + 1, total: m[key].total + 1};
                    //     faceImg.m = m;
                    //     localStorage.setItem('faceImg', JSON.stringify(faceImg));
                    // }
                    dynamicApi.splashScreenReport(this.list[this.active].id, 1).then(); //上报-浏览
                }
            }
        },
        methods: {
            next() {
                this.active++;
            },
            out() {
                this.mEventTrackingToMosso('click', 'advertising', '拍脸图投放-点击');
                this.isInclude = false;
                dynamicApi.splashScreenReport(this.list[this.active].id, 2)
                    .finally(() => {
                        location.href = this.mAddTokenParams(this.list[this.active].link_url); //上报点击
                    });
            }
        },
        created() {
            // dynamicApi.getFaceImg()
            //     .then(data => {
            //         const list = data || [];
            //         for (let i = 0; i < list.length; i++) {
            //             if (list[i].img_v) {
            //                 this.vList.push({
            //                     ...list[i],
            //                     img_url: list[i].img_v
            //                 });
            //             }
            //             if (list[i].img_h) {
            //                 this.hList.push({
            //                     ...list[i],
            //                     img_url: list[i].img_h
            //                 });
            //             }
            //         }
            //
            //         if (window.innerHeight >= window.innerWidth) {
            //             // 竖屏
            //             this.list = this.vList;
            //         } else {
            //             // 横屏
            //             this.list = this.hList;
            //         }
            //     })
            //     .catch(error => {
            //         // this.$toast(error)
            //     });

            dynamicApi.getSplashScreenList()
                .then(list => {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].v_img_url) {
                            this.vList.push({
                                ...list[i],
                                img_url: list[i].v_img_url
                            });
                        }
                        if (list[i].h_img_url) {
                            this.hList.push({
                                ...list[i],
                                img_url: list[i].h_img_url
                            });
                        }
                    }
                    //
                    if (window.innerHeight >= window.innerWidth) {
                        // 竖屏
                        this.list = this.vList;
                    } else {
                        // 横屏
                        this.list = this.hList;
                    }
                })
                .catch(error => {
                    // this.$toast(error)
                })
        }
    }
</script>

<style lang="postcss">
    .igc-face-img {
        position: fixed;
        background: rgba(0, 0, 0, .3);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;

        .ig-img-box {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            @media (orientation: portrait) {
                width: 80%;
                height: 60%;
            }
            @media (orientation: landscape) {
                width: 60%;
                height: 80%;
            }

            > div {
                position: relative;
            }

            img {
                display: block;
                max-width: 100%;
                max-height: -webkit-fill-available;
            }
        }

        .ig--close {
            position: absolute;
            width: 50px;
            height: 50px;
            top: -25px;
            right: -25px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50px;

            > .ig--icon {
                height: 30px;
                width: 30px;
            }
        }
    }
</style>
